import { successMessage } from 'hooks/helpers';
import api from './api';

const BASE_URL = '/ponds';

class PhysicalPondsService {
  constructor() {
    this.httpClient = api;
  }

  mappedJsonData(payload) {
    return payload.map((item) => ({
      area: parseFloat(item['Área']) ?? 0,
      nome: item.Nome,
      tipo: item.Tipo,
      status: item['Status do viveiro'],
      sistema: item['Sistema de produção'],
      protocolo: item.Protocolo,
      profundidade: parseFloat(item.Profundidade) ?? 0,
    }));
  }

  async pondsList() {
    const response = await (await api.get(`${BASE_URL}`)).data;
    return response;
  }

  async importData(payload) {
    try {
      const jsonData = this.mappedJsonData(payload);
      const { status, data } = await this.httpClient.post(`${BASE_URL}/import`, jsonData);

      const { importedData, errors } = data;

      return {
        status,
        importedData,
        errorsData: errors,
        successMessage: successMessage(importedData.length, jsonData.length),
      };
    } catch (err) {
      const errorMessage = err.response?.data?.message;
      throw new Error(errorMessage);
    }
  }
}

export default new PhysicalPondsService();
